import React from "react";
import vi from "../../../assets/common/vi.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

// check input validation
export const CFV = (key, msg, errors) => (
  <div style={{ color: "red", marginBottom: "0px" }}>
    {errors && errors[key] ? (
      msg
    ) : Object.keys(errors).length > 0 ? (
      <img src={vi} alt={"vi"} style={{ width: "20px", marginRight: "0px" }} />
    ) : (
      <div style={{ height: "20px" }} />
    )}
  </div>
);

export const copyToClipBoard = async (copyMe) => {
  try {
    await navigator.clipboard.writeText(copyMe);
    toast.info("הועתק בהצלחה!");
  } catch (err) {
    toast.error("העתקה נכשלה, יש לפנות למנהל המערכת");
  }
};

export const days = (date_1, date_2) => {
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return parseInt(TotalDays);
};

export const parseIsoDate = (date) =>
  date.toISOString().replace(/T.*/, "").split("-").reverse().join("/");

export const dateFormat = (date) =>
  date.replace(/T.*/, "").split("-").reverse().join("/");

export const handleClickScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

export const addAlpha = (color, opacity) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + ".xlsx");
};

export const getImageUrl = () =>
  "https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/callUp/";

export const msg4 = `לקוח יקר זו הודעה אוטומטית. תהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. לשם כך יש להיכנס למערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות`;
export const msg4B = `לקוח יקר, תהליך וידוא ההגעה קרוב לסיומו וזה הרגע להסדיר תשלום 🙏\nנהוג לקזז את עלות השירות מהמתנות באשראי במידה וזה מוסכם מבחינתך אין צורך להתייחס להודעה זו\n\nאם תרצו לשלם עכשיו הסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.\n\n*ניתן לשלם בביט או העברה בנקאית*\n\n*נא לא להעביר ביט למספר הזה כי זה טלפון מוקד, תאמרו לנו איך נוח לכם לשלם ונרשום לכם את הפרטים*`;
export const msg4nC = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\nנראה כי לא עשיתם מתנות באשראי וממש חבל על הכסף שתפסידו, אם תרצו שנסביר לכם למה תאמרו ואם בכל זאת אתם לא רוצים אז אנא להסדיר תשלום דרך המערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות. 🙏`;
export const msg4nBS = `לקוח יקר, תהליך וידוא ההגעה קרוב לסיומו וזה הרגע להסדיר תשלום 🙏\nנהוג לקזז את עלות השירות מהמתנות באשראי אך נראה כי לא עשיתם וממש חבל על הכסף שתפסידו, הסברנו את חשיבות השירות בתחילת התהליך אבל אולי עכשיו לאור התוצאות תרצו שכן לקחת את השירות בסופו של דבר, וגם לא אם לא אז בבקשה נא להסדיר את התשלום\n\nהסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.\n\n*ניתן לשלם בביט או העברה בנקאית*\n\n*נא לא להעביר ביט למספר הזה כי זה טלפון מוקד, תאמרו לנו איך נוח לכם לשלם ונרשום לכם את הפרטים*`;
export const aviadPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לאביעד במספר 0503064555 ולהסדיר תשלום עבור השירות 🙏`;
export const liorWDPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לליאור במספר 0523665635 ולהסדיר תשלום עבור השירות 🙏`;
export const yosefPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליוסף במספר 0504077789 ולהסדיר תשלום עבור השירות 🙏`;
export const TipTopPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0527007397 ולהסדיר תשלום עבור השירות 🙏`;
export const TomerPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0506654051 ולהסדיר תשלום עבור השירות 🙏`;
export const PolPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לפול במספר 0502692682 ולהסדיר תשלום עבור השירות 🙏`;
export const RazPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לרז במספר 0585958777 ולהסדיר תשלום עבור השירות 🙏`;
export const igalPmPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליגאל במספר 0505533440 ולהסדיר תשלום עבור השירות 🙏`;

export const links = {
  BeSimple: "https://callup.ltd/v/besimple/index.html",
  DIY: "https://callup.ltd/v/diy/index.html",
  TipTop: "https://callup.ltd/v/tiptop/index.html",
  "מארגנת החתונות": "https://callup.ltd/v/wd/index.html",
  "משחק הכיסאות": "https://callup.ltd/v/chairsgame/index.html",
  TomerIsakov: "https://callup.ltd/v/tomer/index.html",
  "דובי הפקות": "https://callup.ltd/v/dubi/index.html",
};
